// Force CJS entry: webpack 4 prefers package.json#module which loads marked's ESM
// build that uses `static` class fields — unsupported by the project's Babel preset.
// The CJS build (marked.cjs) is built down to ES2017 and works under webpack 4 + TS 3.9.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const markedModule = require('marked/lib/marked.cjs')
const marked = markedModule.marked || markedModule

export type MdToken = any

export const lex = (src: string): MdToken[] => {
  if (!src) return []
  return marked.lexer(src) as MdToken[]
}

export const lexInline = (src: string): MdToken[] => {
  if (!src) return []
  return marked.lexer(src) as MdToken[]
}
